import {action, computed, observable} from 'mobx';
import {TechseeBaseController} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-controller';

export enum ConnectivityIssueEvents {
    CLOSE_SESSION = 'CLOSE_SESSION'
}

export interface IConnectivityIssuePopupController {
    readonly isVisible: boolean;
    translate(token: string, data?: Record<string, unknown>): string;
    show(): void;
    hide(): void;
    tryAgain(): void;
    closeSession(): void;
}

export class ConnectivityIssuePopupController
    extends TechseeBaseController
    implements IConnectivityIssuePopupController
{
    @observable private _isVisible: boolean = false;

    constructor() {
        super();

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.tryAgain = this.tryAgain.bind(this);
        this.closeSession = this.closeSession.bind(this);
    }

    @action
    show() {
        this._isVisible = true;
    }

    @action
    hide() {
        this._isVisible = false;
    }

    @action
    tryAgain() {
        this.hide();
    }

    @action
    closeSession() {
        this.hide();
        this.emit(ConnectivityIssueEvents.CLOSE_SESSION);
    }

    @computed
    get isVisible() {
        return this._isVisible;
    }
}
